<template>
	<nav class="c-multi-level-menu" @keyup.esc="resetOpenedMenuLists()">
		<ul
			v-if="multiLevelMenuItems?.length"
			class="c-multi-level-menu__list c-multi-level-menu__list-primary"
		>
			<multi-level-menu-item
				v-for="primary in multiLevelMenuItems"
				:key="primary.ID"
				:menu-item="primary"
				is-primary-menu-item
				@toggle-menu-lists="toggleCollapsedItems(primary, multiLevelMenuItems)"
			    @clear-lists="resetOpenedMenuLists()"
			>
				<div
					class="c-multi-level-menu__overlay"
					:class="{ 'c-multi-level-menu__overlay--open': primary.isOpen }"
				>
					<div class="c-multi-level-menu__title-block">
						<h2 class="c-multi-level-menu__title">{{ primary.LinkText }}</h2>
					</div>
					<ul
						v-if="primary.SubMenuItems && primary.SubMenuItems.length"
						class="c-multi-level-menu__list c-multi-level-menu__list-secondary"
						:class="{
							'c-multi-level-menu__list--open': primary.isOpen && primary.ID === activeListId,
						}"
					>
						<multi-level-menu-item
							v-for="secondary in primary.SubMenuItems"
							:key="secondary.ID"
							:menu-item="secondary"
							@toggle-menu-lists="
								toggleCollapsedItems(secondary, primary.SubMenuItems, primary);
								toggleOverlayItems(secondary, 'third');
							"
						>
							<ul
								v-if="secondary.SubMenuItems && secondary.SubMenuItems.length"
								class="c-multi-level-menu__list c-multi-level-menu__list-tertiary fade-in-list"
								:class="{
									'c-multi-level-menu__list--open': secondary.isOpen && secondary.ID === activeListId,
									'c-multi-level-menu__list-tertiary--open': secondary.isOpen,
								}"
							>
								<multi-level-menu-item
									v-for="tertiary in secondary.SubMenuItems"
									:key="tertiary.ID"
									:menu-item="tertiary"
									@toggle-menu-lists="
										toggleCollapsedItems(tertiary, secondary.SubMenuItems, secondary)
									"
								>
									<ul
										v-if="tertiary.SubMenuItems && tertiary.SubMenuItems.length"
										class="c-multi-level-menu__list c-multi-level-menu__list-quaternary fade-in-list"
										:class="{
											'c-multi-level-menu__list--open':
												tertiary.isOpen && tertiary.ID === activeListId,
											'c-multi-level-menu__list-quaternary--open': tertiary.isOpen,
										}"
									>
										<multi-level-menu-item
											v-for="quaternary in tertiary.SubMenuItems"
											:key="quaternary.ID"
											:menu-item="quaternary"
										/>
									</ul>
								</multi-level-menu-item>
							</ul>
						</multi-level-menu-item>
					</ul>
					<ul
						v-if="thirdLevelMenuItems.length"
						class="c-multi-level-menu__list c-multi-level-menu__list-side fade-in-list"
					>
						<multi-level-menu-item
							v-for="thirdLevelMenuItem in thirdLevelMenuItems"
							:key="thirdLevelMenuItem.ID"
							:menu-item="thirdLevelMenuItem"
							@toggle-menu-lists="toggleOverlayItems(thirdLevelMenuItem, 'fourth')"
						/>
					</ul>
					<ul
						v-if="fourthLevelMenuItems.length"
						class="c-multi-level-menu__list c-multi-level-menu__list-side fade-in-list"
					>
						<multi-level-menu-item
							v-for="fourthLevelMenuItem in fourthLevelMenuItems"
							:key="fourthLevelMenuItem.ID"
							:menu-item="fourthLevelMenuItem"
						/>
					</ul>
				</div>
			</multi-level-menu-item>
		</ul>
	</nav>
</template>

<script>
	import MultiLevelMenuItem from 'shared/components/MultiLevelMenu/multiLevelMenuItem.vue';

	export default {
		name: 'multi-level-menu',
		components: { MultiLevelMenuItem },
		props: {
			vm: Object,
		},
		emits: ['toggle-menu-lists'],
		data() {
			return {
				multiLevelMenuItems: [],
				thirdLevelMenuItems: [],
				fourthLevelMenuItems: [],
				activeListId: null,
			};
		},
		computed: {
			isOverlayOpen() {
				return this.multiLevelMenuItems.some(item => item.isOpen);
			},
		},
		created() {
			window.addEventListener('pageshow', event => {
				event.persisted && window.location.reload();
			});
			this.setOpenedMenuLists();
		},
		mounted() {
			window.addEventListener('click', this.clickOutside);
		},
		beforeUnmount() {
			window.removeEventListener('click', this.clickOutside);
		},
		methods: {
			clickOutside(event) {
				if (this.isOverlayOpen && !document.querySelector('.c-multi-level-menu').contains(event.target)) {
					this.resetOpenedMenuLists();
				}
			},
			setOpenedMenuLists() {
				let temporarySubMenuItems = [];
				this.multiLevelMenuItems = this.vm.BaseViewModel.map(primaryItem => {
					return {
						...primaryItem,
						isOpen: false,
						SubMenuItems: primaryItem.SubMenuItems.map(secondaryItem => {
							if (secondaryItem.HasSubMenuItems) {
								temporarySubMenuItems = secondaryItem.SubMenuItems.map(tertiaryItem => {
									return { ...tertiaryItem, isOpen: false };
								});
							}
							return {
								...secondaryItem,
								isOpen: false,
								SubMenuItems: temporarySubMenuItems,
							};
						}),
					};
				});
			},
			resetOpenedMenuLists() {
				this.multiLevelMenuItems.forEach(menuItem => {
					menuItem.isOpen = false;
					this.traverseTree(menuItem);
				});
				this.thirdLevelMenuItems = [];
				this.fourthLevelMenuItems = [];
			},
			toggleCollapsedItems(renderedItem, renderedList, renderedParent = {}) {
				if (Object.keys(renderedParent).length === 0 && !renderedItem.isOpen) {
					this.thirdLevelMenuItems = [];
					this.fourthLevelMenuItems = [];
				}
				renderedItem.isOpen = !renderedItem.isOpen;
				this.activeListId = renderedItem.isOpen ? renderedItem.ID : renderedParent?.ID;
				renderedList.forEach(menuItem => {
					if (menuItem !== renderedItem) {
						menuItem.isOpen = false;
					}
					this.traverseTree(menuItem);
				});
			},
			toggleOverlayItems(overlayMenuItem, subMenuLabel) {
				if (subMenuLabel === 'third') {
					if (overlayMenuItem.isOpen) {
						this.thirdLevelMenuItems = overlayMenuItem.SubMenuItems;
					} else {
						this.thirdLevelMenuItems = [];
					}
					this.fourthLevelMenuItems = [];
				} else {
					overlayMenuItem.isOpen = !overlayMenuItem.isOpen;
					this.thirdLevelMenuItems.forEach(thirdLevelItem => {
						if (thirdLevelItem !== overlayMenuItem) {
							thirdLevelItem.isOpen = false;
						}
					});
					if (overlayMenuItem.isOpen) {
						this.fourthLevelMenuItems = overlayMenuItem.SubMenuItems;
					} else {
						this.fourthLevelMenuItems = [];
					}
				}
			},
			traverseTree(menuItem) {
				if (menuItem.HasSubMenuItems) {
					menuItem.SubMenuItems.forEach(subMenuItem => {
						subMenuItem.isOpen = false;
						this.traverseTree(subMenuItem);
					});
				}
			},
		},
	};
</script>
